/**
 * AEOC consolidated-PDP title-row price sync
 *
 * The AEOC theme's product-page-aeoc-* sections render a custom title row that includes
 * a price element with [data-aeoc-title-row-price]. The element is rendered server-side
 * from Liquid on page load and has no JS listener attached to variant changes.
 *
 * Result: when the customer picks a different size pill (e.g. 1.5kg → 4.5kg), every other
 * element updates EXCEPT this title-row price. The customer sees "$31.00" even when 4.5kg
 * ($85) is selected.
 *
 * This script wires the listener. Runs only on pages where the element exists, so it's
 * a safe no-op on homepage/collection/other pages.
 */
(function () {
  'use strict';

  function formatMoney(cents) {
    if (typeof cents !== 'number') return '';
    var dollars = (cents / 100);
    // Match Shopify's default money format for AUD: "$31.00"
    return '$' + dollars.toFixed(2);
  }

  /**
   * Read the variant array from the JSON script embedded by the Shopify variant-radios
   * (or variant-selects) custom element. Returns null if no variant data found.
   */
  function findVariantData() {
    var scripts = document.querySelectorAll(
      'variant-radios script[type="application/json"], variant-selects script[type="application/json"]'
    );
    for (var i = 0; i < scripts.length; i++) {
      try {
        var data = JSON.parse(scripts[i].textContent);
        if (data && Array.isArray(data.variants) && data.variants.length && typeof data.variants[0].price === 'number') {
          return data.variants;
        }
      } catch (e) { /* not the right script tag */ }
    }
    // Fallback: any <script type="application/json"> with a variants array
    var all = document.querySelectorAll('script[type="application/json"]');
    for (var j = 0; j < all.length; j++) {
      try {
        var d = JSON.parse(all[j].textContent);
        if (d && Array.isArray(d.variants) && d.variants.length && typeof d.variants[0].price === 'number') {
          return d.variants;
        }
      } catch (e) { /* not it */ }
    }
    return null;
  }

  function getSelectedVariantId() {
    // The cart-add form's hidden input[name="id"] tracks the currently-selected variant.
    var hidden = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    if (hidden && hidden.value) return hidden.value;
    // Fallback: read from URL ?variant=...
    var m = window.location.search.match(/[?&]variant=(\d+)/);
    if (m) return m[1];
    return null;
  }

  /**
   * Fallback: derive the variant from currently-checked radios. The AEOC theme uses
   * `name="Scent"` and `name="Size"` (raw option names, not `options[...]` wrappers),
   * so we read the checked radios inside the variant-radios picker and match against
   * each variant's `options` array (which holds option values in declaration order).
   */
  function findVariantBySelectedRadios(variants) {
    var picker = document.querySelector('variant-radios, variant-selects');
    if (!picker) return null;
    var selections = [];
    // Radios first
    var checked = picker.querySelectorAll('input[type="radio"]:checked');
    for (var i = 0; i < checked.length; i++) selections.push(checked[i].value);
    // Selects (variant-selects mode)
    var selects = picker.querySelectorAll('select');
    for (var s = 0; s < selects.length; s++) {
      if (selects[s].value) selections.push(selects[s].value);
    }
    if (!selections.length) return null;
    for (var v = 0; v < variants.length; v++) {
      var opts = variants[v].options || [];
      if (opts.length !== selections.length) continue;
      var matchAll = true;
      for (var k = 0; k < opts.length; k++) {
        if (opts[k] !== selections[k]) { matchAll = false; break; }
      }
      if (matchAll) return variants[v];
    }
    return null;
  }

  function updateTitleRowPrice() {
    var priceEls = document.querySelectorAll('[data-aeoc-title-row-price]');
    if (!priceEls.length) return; // Not on a consolidated PDP — silent no-op
    var variants = findVariantData();
    if (!variants) return;
    var match = null;
    // Path 1 (preferred): match the cart form's hidden id input
    var variantId = getSelectedVariantId();
    if (variantId) {
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === String(variantId)) { match = variants[i]; break; }
      }
    }
    // Path 2 (fallback): derive from currently-checked radios
    if (!match) match = findVariantBySelectedRadios(variants);
    if (!match || typeof match.price !== 'number') return;
    var html = buildPriceHtml(match);
    for (var j = 0; j < priceEls.length; j++) {
      if (priceEls[j].innerHTML !== html) priceEls[j].innerHTML = html;
    }
  }

  // Build the title-row price markup, with a struck-through compare-at when on sale.
  function buildPriceHtml(match) {
    var now = formatMoney(match.price);
    var cmp = (typeof match.compare_at_price === 'number') ? match.compare_at_price : 0;
    if (cmp > match.price) {
      return '<s class="aeoc-title-price-row__was">' + formatMoney(cmp) + '</s> ' +
             '<span class="aeoc-title-price-row__now">' + now + '</span>';
    }
    return now;
  }

  function init() {
    // Initial sync (in case Liquid output was stale for the first variant)
    updateTitleRowPrice();

    // Catch any variant-related input change. The variant-radios custom element
    // updates the hidden form input[name="id"] on selection — we listen and re-sync.
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var inPicker = t.closest('variant-radios') || t.closest('variant-selects');
      var isIdInput = t.matches && (t.matches('input[name="id"]') || t.matches('select[name="id"]'));
      if (inPicker || isIdInput) {
        // Small delay so the variant-radios component has time to update the hidden input.
        setTimeout(updateTitleRowPrice, 60);
      }
    });

    // Some themes also dispatch a 'variant:change' custom event — listen defensively.
    document.addEventListener('variant:change', function () {
      setTimeout(updateTitleRowPrice, 0);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
